import { createContext } from 'react';
import { UseAuthReturn } from '../hooks/useAuth';

type AuthContextType = UseAuthReturn;

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
